module.exports = __webpack_public_path__ + "static/media/avatar-8.e581598b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-8.png
// module id = 247
// module chunks = 0